class UrlParams {
  constructor() {
    this.links = document.querySelectorAll('a');
    this.queryParams = this.getQueryParams();

    this.addEventListeners();
    this.setupFormReadyListener();
  }

  // Only populate the hidden fields when hubspot forms have fully loaded
  setupFormReadyListener() {
    document.addEventListener('hbsptFormReady', () => {
      this.populateHiddenFields();
    });
  }

  // Determines if page is ftx related
  isTargetUrl() {
    const validUrls = ['/ftx-distributions/', '/ftx-institutions/'];
    const currentPath = window.location.pathname;
    return validUrls.some((url) => currentPath.endsWith(url));
  }

  getQueryParams() {
    const params = new URLSearchParams(window.location.search);
    const paramObj = {};
    params.forEach((value, key) => {
      paramObj[key] = value;
    });
    return paramObj;
  }

  mergeQueryParams(existingParams, additionalParams) {
    const merged = {...existingParams};
    for (const key in additionalParams) {
      if (Object.prototype.hasOwnProperty.call(additionalParams, key)) {
        merged[key] = additionalParams[key];
      }
    }
    return merged;
  }

  buildQueryString(params) {
    return Object.keys(params)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');
  }

  addEventListeners() {
    this.links.forEach((link) => {
      link.addEventListener('click', () => {
        const url = new URL(link.href, window.location.origin);

        // Parse existing query parameters from the link
        const existingParams = {};
        url.searchParams.forEach((value, key) => {
          existingParams[key] = value;
        });

        const mergedParams = this.mergeQueryParams(existingParams, this.queryParams);
        const updatedQueryString = this.buildQueryString(mergedParams);

        if (updatedQueryString) {
          link.href = `${url.origin}${url.pathname}?${updatedQueryString}`;
        }
      });
    });
  }

  populateHiddenFields() {
    if (!this.isTargetUrl()) return;

    const fieldsToPopulate = ['email', 'account_id', 'applicant_id', 'timestamp', 'customer_type', 'pageUrl', 'pageName'];

    document.querySelectorAll('form').forEach((form) => {
      fieldsToPopulate.forEach((field) => {
        if (this.queryParams[field] || field == 'pageUrl' || field == 'pageName') {
          if (field == 'customer_type') {
            field = 'ftx_enterprise_types';
            this.queryParams[field] = this.queryParams[field] == 'KycType.INDIVIDUAL' ? 'retail' : 'institution';
          } else if (field == 'pageUrl') {
            this.queryParams[field] = window.location.href;
          } else if (field == 'pageName') {
            const pathParts = window.location.pathname.split('/').filter(Boolean);
            this.queryParams[field] = pathParts[pathParts.length - 1] ?? '';
          }

          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = field;
          hiddenInput.value = this.queryParams[field];
          form.appendChild(hiddenInput);
        }
      });
    });
  }
}

new UrlParams();
